import { Eyebrow, HudCorners, Reveal } from "./bits";

const Certificates = ({ t }) => {
  return (
    <section id="certificates" data-testid="certificates-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>{t.eyebrow}</Eyebrow>
          <h2 className="mt-5 font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#0B0D10]">
            {t.title}
          </h2>
          <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-neutral-700">{t.subtitle}</p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-8">
          {t.items.map((cert) => (
            <Reveal key={cert.id} delay={0.1}>
              <div
                data-testid={`certificate-card-${cert.id}`}
                className="group relative bg-white border border-[#CBD3DF] rounded-sm overflow-hidden hover:border-emerald/60 transition-colors duration-500"
              >
                <img
                  src={cert.thumb}
                  alt={cert.id}
                  loading="lazy"
                  className="w-full object-contain transition-transform duration-700 group-hover:scale-[1.02]"
                />
                <HudCorners className="border-transparent group-hover:border-emerald/50 transition-colors duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certificates;
